// extracted by mini-css-extract-plugin
export var body = "_df-5";
export var closeButton = "_df-f";
export var container = "_df-1";
export var content = "_df-2";
export var cta = "_df-c";
export var ctaLabel = "_df-b";
export var eyebrow = "_df-3";
export var howTo = "_df-6";
export var image = "_df-e";
export var modal = "_df-0";
export var socialButton = "_df-d";
export var stepCard = "_df-8";
export var stepLabel = "_df-a";
export var stepNumber = "_df-9";
export var steps = "_df-7";
export var title = "_df-4";